/* ============================================
   A Local Tribe — Homepage JS v2
   File: assets/alt-homepage.js

   Add ONCE to your theme.liquid before </body>:
   {{ 'alt-homepage.js' | asset_url | script_tag }}
   ============================================ */

(function () {
  'use strict';

  /* ── Scroll reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('.alt-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── AJAX Add to Cart ── */
  window.altAddToCart = function (variantId, btn) {
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added!';
        btn.style.background = 'var(--alt-rust)';
        /* Try to open theme cart drawer */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(function () {
          btn.textContent = orig;
          btn.disabled = false;
          btn.style.background = '';
        }, 2200);
      })
      .catch(function () {
        btn.textContent = orig;
        btn.disabled = false;
      });
  };

  /* ── Wishlist toggle (visual) ── */
  window.altToggleWish = function (btn) {
    if (btn.textContent === '♡') {
      btn.textContent = '♥';
      btn.style.color = 'var(--alt-terracotta)';
    } else {
      btn.textContent = '♡';
      btn.style.color = '';
    }
  };

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
  });

})();
